import { render, staticRenderFns } from "./KitProgressCircular.vue?vue&type=template&id=570ce2d5&scoped=true&"
import script from "./KitProgressCircular.vue?vue&type=script&lang=ts&"
export * from "./KitProgressCircular.vue?vue&type=script&lang=ts&"
import style0 from "./KitProgressCircular.vue?vue&type=style&index=0&id=570ce2d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ce2d5",
  null
  
)

export default component.exports